import { useEffect, useState } from 'react'

export function useCountUp(target: number, duration = 1600, enabled = false) {
  const [count, setCount] = useState(0)

  useEffect(() => {
    if (!enabled) return
    let startTime: number | null = null

    const step = (timestamp: number) => {
      if (startTime === null) startTime = timestamp
      const progress = Math.min((timestamp - startTime) / duration, 1)
      // ease-out quad — достаточно плавно и без зависания в конце
      const eased = 1 - Math.pow(1 - progress, 2)
      setCount(Math.round(eased * target))
      if (progress < 1) requestAnimationFrame(step)
    }

    const id = requestAnimationFrame(step)
    return () => cancelAnimationFrame(id)
  }, [enabled, target, duration])

  return count
}
